// extracted by mini-css-extract-plugin
module.exports = {"overflow":"PaginationSelect_overflow__1oDrT"};